export class RecordTimeUnit {
    static UNDEFINED = -1;
    static MINUTE = 1;
    static HOUR = 2;
    static DAY = 3;
}
